// frontend/src/components/FlagDisplay.js
import React, { useState } from 'react';
import { getCountryCode } from '../utils/countryFlags';

const FlagDisplay = ({ teamName, size = 'md' }) => {
  const [imageError, setImageError] = useState(false);
  const countryCode = getCountryCode(teamName);
  
  // Size configurations
  const sizeClasses = {
    sm: 'w-6 h-6',
    md: 'w-10 h-10',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16'
  };
  
  const sizeClass = sizeClasses[size] || sizeClasses.md;
  
  // If no country code found or image failed, show nothing
  if (!countryCode || imageError) {
    return null;
  }
  
  // Use Flagpedia CDN for flag images - works everywhere
  const flagUrl = `https://flagcdn.com/48x36/${countryCode.toLowerCase()}.png`;
  const flagUrl2x = `https://flagcdn.com/96x72/${countryCode.toLowerCase()}.png`;
  
  return (
    <img
      src={flagUrl}
      srcSet={`${flagUrl} 1x, ${flagUrl2x} 2x`}
      alt={`${teamName} flag`}
      className={`${sizeClass} object-contain inline-block`}
      loading="lazy"
      onError={() => setImageError(true)}
    />
  );
};

export default FlagDisplay;